import React from "react";
import { SDLCMetadata } from "@sscs/types";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import SummaryCell from "./SummaryCell/SummaryCell";
const generateFooterContent = (statistics) => {
    if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_mandate_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_mandate_k],
            label: "patch mandated",
            verdict: "MANDATE",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_malware_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_malware_k],
            label: "malware exploited",
            verdict: "MALWARE",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_exploit_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_exploit_k],
            label: "with proven exploit",
            verdict: "EXISTS",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_critical_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_critical_k],
            label: "critical severity",
            verdict: "critical",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_high_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_high_k],
            label: "high severity",
            verdict: "high",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_medium_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_medium_k],
            label: "medium severity",
            verdict: "medium",
        };
    }
    else if (statistics[SDLCMetadata.vulnerability_metrics_t.vuln_low_k] > 0) {
        return {
            count: statistics[SDLCMetadata.vulnerability_metrics_t.vuln_low_k],
            label: "low severity",
            verdict: "low",
        };
    }
    else {
        return {
            count: null,
            label: "No known vulnerabilities",
            verdict: null,
        };
    }
};
const Vulnerabilities = ({ statistics, footerWrapper, }) => {
    const { count, label, verdict } = generateFooterContent(statistics);
    const totalCount = statistics[SDLCMetadata.vulnerability_metrics_t.vuln_total_k] -
        statistics[SDLCMetadata.vulnerability_metrics_t.vuln_triaged_k];
    return (React.createElement(SummaryCell, { label: "Vulnerabilities", value: totalCount.toLocaleString(), subline: React.createElement(RenderChildrenWrapper, { wrapper: footerWrapper && ((children) => footerWrapper(verdict, children)) }, count ? (React.createElement("span", null,
            count.toLocaleString(),
            " ",
            label)) : (React.createElement("span", null, label))) }));
};
export default Vulnerabilities;
//# sourceMappingURL=Vulnerabilities.js.map